import axios from "axios"
import { Message } from "element-ui"
import * as Cache from "@/utils/cache"
import { blobToJson } from "@/utils/blob"

// 创建一个 axios 实例
const service = axios.create({
  timeout: 20000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = Cache.get("token")
    // 设置令牌 token
    if (token) {
      config.headers["token"] = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.config.responseType === "blob") {
      if (res.type === "text/xml") {
        return res
      } else {
        // 将 blob 解析为 json
        blobToJson(res, ({ message }) => {
          Message({
            message: message || "错误请求",
            type: "error"
          })
        })
        return Promise.reject()
      }
    }
    // 暂不判断 res.code
    return res
  },
  error => {
    console.dir(error)
    const message = error.code === "ECONNABORTED" ? "请求超时，请重试！" : error.message
    Message({
      message,
      type: "error"
    })
    return Promise.reject(error)
  }
)

export default service
